/**
 *
 * Return the binding period based on selected payment by looking at the downpaytime in months
 *
 * The current logic is this: Instead of having a radio button that allows the user
 * to select a binding period for a subscription or not, we make it so that if the
 * user chooses direct payment (down pay time 1 month) it gets no binding period,
 * but if the user chooses monthly payment (down pay time >1 month) it gets a binding
 * period of 24 months.
 *
 * We localize this business logic to a single function here in order to document this
 * important quirk, and also to make it easy to trace the relevant places in the code
 * in the future, in case it's decided to implement a dedicated switch/checkbox for
 * the binding period.
 */
export const determineSelectedBindingPeriod = (downPayTime: number) => {
  return downPayTime === 1 ? 0 : 24;
};
